import { useState } from "react";

/* Shared account-ID input for registration, browser sign-up, and trial renewal. */
export function sanitizeAccountId(raw) {
  const value = String(raw ?? "");
  return value.replace(/[^0-9]/g, "");
}

export function useAccountIdField() {
  const [accountId, setAccountId] = useState("");
  const onChange = (e) => setAccountId(sanitizeAccountId(e.target.value));

  // Spread onto the <input>; keeps value/filtering/keyboard type in one place.
  const inputProps = (t) => ({
    value: accountId,
    onChange,
    placeholder: t.reg_id_placeholder,
    inputMode: "numeric",
    autoComplete: "off",
    autoCapitalize: "none",
    autoCorrect: "off",
    spellCheck: false,
    maxLength: 32,
  });

  const hint = (t) => t.reg_id_hint_pocket;
  return { accountId, inputProps, hint };
}
